function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
export var ImageComponent = function ImageComponent(_ref) {
  var image = _ref.image,
    animationClass = _ref.animationClass,
    classVariation = _ref.classVariation,
    mobileFlag = _ref.mobileFlag;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    exitClass = _useState2[0],
    setExitClass = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    currImage = _useState4[0],
    setImage = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    newValue = _useState6[0],
    isNewValue = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    imageAnimation = _useState8[0],
    setAnimation = _useState8[1];
  var animationFunction = function animationFunction() {
    setExitClass('');
    setImage(image);
    setAnimation(animationClass);
  };
  useEffect(function () {
    if (image.image) {
      var isNewValues = currImage && currImage.image.src != image.image.src;
      isNewValue(isNewValues);
      setAnimation('');
      if (isNewValues) {
        setExitClass(mobileFlag ? '' : 'exit');
      } else {
        setExitClass('');
      }
      var animationTimer = setTimeout(function () {
        return animationFunction();
      }, mobileFlag ? 100 : 300);
      return function () {
        return clearTimeout(animationTimer);
      };
    }
  }, [image]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, currImage && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classVariation, " section-image ").concat(newValue ? imageAnimation + exitClass : ''),
    style: {
      backgroundImage: mobileFlag ? "url(\"".concat(currImage.image.src, "\")") : ''
    }
  }, currImage.image.src && !mobileFlag && /*#__PURE__*/React.createElement("img", {
    src: currImage.image.src,
    alt: currImage.image.alt ? currImage.image.alt : 'decoration image'
  })));
};
export var ImageContainer = function ImageContainer(_ref2) {
  var currentData = _ref2.currentData,
    scrollState = _ref2.scrollState,
    mobileFlag = _ref2.mobileFlag;
  var mobileImage = currentData.mobileImage ? true : false;
  return /*#__PURE__*/React.createElement(React.Fragment, null, currentData.background && /*#__PURE__*/React.createElement(ImageComponent, {
    image: currentData.background,
    classVariation: mobileImage ? 'hide-on-mobile' : '',
    animationClass: scrollState,
    mobileFlag: mobileFlag
  }), currentData.mobileImage && /*#__PURE__*/React.createElement(ImageComponent, {
    image: currentData.mobileImage,
    classVariation: 'mobile-image ' + scrollState,
    animationClass: '',
    mobileFlag: mobileFlag
  }), currentData.backgroundCenterRight && /*#__PURE__*/React.createElement(ImageComponent, {
    image: currentData.backgroundCenterRight,
    classVariation: 'center-right with-background-color' + scrollState + mobileImage ? ' hide-on-mobile' : '',
    animationClass: scrollState,
    mobileFlag: mobileFlag
  }), currentData.backgroundBottomWithColor && /*#__PURE__*/React.createElement(ImageComponent, {
    image: currentData.backgroundBottomWithColor,
    classVariation: 'with-background-color' + mobileImage ? ' hide-on-mobile' : '',
    animationClass: scrollState,
    mobileFlag: mobileFlag
  }), currentData.additionalImage && /*#__PURE__*/React.createElement(ImageComponent, {
    image: currentData.additionalImage,
    classVariation: 'additional-image' + scrollState + mobileImage ? ' hide-on-mobile' : '',
    animationClass: scrollState,
    mobileFlag: mobileFlag
  }));
};